import styled from "styled-components";

export const WrapperContainer = styled.div.attrs({})`
  background: transparent;
  border-radius: 24px;
  @media (max-width: 502px) {
    padding: 0px;
    background: transparent;
  }
`;

export const WrapperContent = styled.div.attrs({})`
  padding: 24px;
  background: ${p => p.theme.palette.colors.surfaceElevatedSoft};
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-shadow: 0 24px 56px ${p => p.theme.palette.colors.shadowStrong};
  @media (max-width: 502px) {
    padding: 0px;
    background: transparent;
  }
`;

export const WrapperHeader = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;
    @media (max-width: 502px) {
    // padding: 24px;
  }
`;

export const WrapperHeaderTitle = styled.div.attrs({})`
  font-family: Gilroy;
  font-size: 24px;
  font-weight: 700;
  color: ${p => p.theme.palette.colors.text};
`;

export const WrapperOptions = styled.div.attrs({})`
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${p => p.active ? p.theme.palette.colors.text : p.theme.palette.colors.subdued};
  padding: 10px 0;
  border-bottom: 2px solid ${p => p.active ? p.theme.palette.blue.main : 'transparent'};
  cursor: pointer;
`;
export const WrapperOptionsContainer = styled.div.attrs({})`
  display: flex;
  gap: 14px;
`;

export const InputSearchContainer = styled.div.attrs({
})`
    width: 328px;

    @media (max-width: 502px) {
      width: 100%;
    }
`;
export const ActionsContainer = styled.div.attrs({
})`
  display: flex;
  gap: 32px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 502px) {
    width: 100%;
  }
`;
